import React from 'react'
import { AppBar, Toolbar, Box, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'

import { SvgIconComponent } from '@mui/icons-material'

type NavItem = {
  label: string
  link: string
  icon?: SvgIconComponent
  children?: NavItem[]
}

export type NavItemList = NavItem[]

const Navbar = () => {
  const navigate = useNavigate()

  return (
    <AppBar
      position="sticky"
      color="default"
      elevation={0}
      sx={{
        p: '0',
        border: 'none',
        zIndex: 1400,
      }}
    >
      <Toolbar
        sx={{
          bgcolor: 'background.default',
          borderBottom: '1px solid #eee',
          py: 1,
          justifyContent: 'space-between',
        }}
      >
        <Box display="flex" alignItems="center" gap={2}>
          <img
            src="/logo.png"
            alt="logo"
            style={{ height: 40, cursor: 'pointer', paddingLeft: '40px' }}
            onClick={() => navigate('/')}
          />
        </Box>
      </Toolbar>

      <Box
        sx={{
          bgcolor: 'secondary.main',
          alignItems: 'end',
          display: 'flex',
          justifyContent: 'end',
          py: 0.5,
        }}
      >
        <Box sx={{ paddingRight: '80px' }}>
          <Button
            variant="outlined"
            size="small"
            component="a"
            href="https://jetpot.co/login"
            target="_blank"
            rel="noopener noreferrer"
          >
            Login
          </Button>
        </Box>
      </Box>
    </AppBar>
  )
}

export default Navbar
